import React from "react";

export const docMenu = [
  {
    name: "Introduction",
    dropDownItems: [
      {
        name: "Introduction",
        routerPath: "/new-go-shops/introduction",
      },
      {
        name: "Server requirements",
        routerPath: "/new-go-shops/recommendations",
      },
    ],
  },
  {
    name: "Backend Api",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/new-go-shops/server",
      },
      {
        name: "Installation",
        routerPath: "/new-go-shops/mandatory-setup-backend",
      },
      {
        name: "Payment installation",
        routerPath: "/new-go-shops/payment-installation",
      },
      {
        name: "Image settings",
        routerPath: "/new-go-shops/image-settings",
      },
      {
        name: "Troubleshooting",
        routerPath: "/new-go-shops/troubleshooting-backend",
      },
    ],
  },
  {
    name: "Admin Panel",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/new-go-shops/admin",
      },
      {
        name: "Installation",
        routerPath: "/new-go-shops/install-on-server",
      },
      {
        name: "Troubleshooting",
        routerPath: "/new-go-shops/troubleshooting-admin",
      },
    ],
  },
  {
    name: "Customer Website",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/new-go-shops/front",
      },
      {
        name: "Installation",
        routerPath: "/new-go-shops/mandatory-setup-web",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Customer App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/new-go-shops/mobile-app",
      },
      {
        name: "Installation",
        routerPath: "/new-go-shops/mandatory-setup-customer",
      },
      {
        name: "Customization",
        routerPath: "/new-go-shops/customization-customer",
      },
      {
        name: "App build & release",
        routerPath: "/new-go-shops/customer-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  {
    name: "Seller and Driver App",
    dropDownItems: [
      {
        name: "Requirements",
        routerPath: "/new-go-shops/vendor-app",
      },
      {
        name: "Installation",
        routerPath: "/new-go-shops/mandatory-setup-vendor",
      },
      {
        name: "Customization",
        routerPath: "/new-go-shops/customization-vendor",
      },
      {
        name: "App build & release",
        routerPath: "/new-go-shops/vendor-app-build-release",
      },
      // {
      //   name: "Troubleshooting",
      //   routerPath: "/",
      // },
    ],
  },
  // {
  //   name: "Driver App",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/new-go-shops/driver-app",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/new-go-shops/mandatory-setup-deliveryboy",
  //     },
  //     {
  //       name: "Customization",
  //       routerPath: "/new-go-shops/customization-deliveryboy",
  //     },
  //     {
  //       name: "App build & release",
  //       routerPath: "/new-go-shops/deliveryboy-app-build-release",
  //     },
  //     // {
  //     //   name: "Troubleshooting",
  //     //   routerPath: "/",
  //     // },
  //   ],
  // },
  // {
  //   name: "Pos App",
  //   dropDownItems: [
  //     {
  //       name: "Requirements",
  //       routerPath: "/new-go-shops/pos-app",
  //     },
  //     {
  //       name: "Installation",
  //       routerPath: "/new-go-shops/mandatory-setup-pos",
  //     },
  //     {
  //       name: "Customization",
  //       routerPath: "/new-go-shops/customization-pos",
  //     },
  //     {
  //       name: "App build & release",
  //       routerPath: "/new-go-shops/pos-app-build-release",
  //     },
  //     // {
  //     //   name: "Troubleshooting",
  //     //   routerPath: "/",
  //     // },
  //   ],
  // },
  {
    name: "Firebase setup",
    dropDownItems: [
      {
        name: "Website",
        routerPath: "/new-go-shops/firebase-web",
      },
      {
        name: "Mobile",
        routerPath: "/new-go-shops/firebase-mobile",
      }
    ],
    // routerPath: "/new-go-shops/firebase",
  },
  {
    name: "Update",
    routerPath: "/new-go-shops/update",
  },
];

export const payments = [
  {
    icon: (
        <img
            src={"./assets/img/root/paypal.png"}
            alt="img"
            width="80"
            height="80"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/stripe.png"}
            alt="img"
            width="80"
            height="80"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/razorpay.png"}
            alt="img"
            width="80"
            height="80"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/paystack.jpeg"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/pay-tabs.jpg"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/flw.png"}
            alt="img"
            width="110"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/mercado-pago.jpg"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/moyasar.png"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/mollie.png"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
  {
    icon: (
        <img
            src={"./assets/img/root/maksekeskus.png"}
            alt="img"
            width="120"
            height="120"
        />
    ),
  },
];

